import { ModalFooter, ModalPrimaryButton, ModalSecondaryButton } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/useTranslations';

import styles from './ModalButtons.module.scss';

const ModalButtons = ({
  handleCancel,
  isLoading,
  handleAuthorize,
}: {
  handleCancel: () => any;
  isLoading: boolean;
  handleAuthorize: () => any;
}) => {
  const { t } = useTranslation();

  return (
    <ModalFooter>
      <ModalSecondaryButton
        id="Click_CloseModal"
        className={styles.modalCancel}
        onClick={handleCancel}
        disabled={isLoading}
        data-zta="closeModalBtnBottom">
        {t('general.button.back')}
      </ModalSecondaryButton>
      <ModalPrimaryButton
        onClick={handleAuthorize}
        disabled={isLoading}
        isLoading={isLoading}
        loadingIconType="paw"
        data-zta="retryPaymentSubmitBtn">
        {t('checkout.payment.pay')}
      </ModalPrimaryButton>
    </ModalFooter>
  );
};

export default ModalButtons;
